/** Builder section types of the `bikiniContinue` templates. No imports: `entities/LandingPage` reads it. */
export const bikiniContinueSectionTypes = [
  "bikiniContinueLandingEffects",
  "bikiniContinueHeader",
  "bikiniContinueHero",
  "bikiniContinueTransformations",
  "bikiniContinueReviews",
  "bikiniContinueWhy",
  "bikiniContinueCtaButton",
  "bikiniContinueProgram",
  "bikiniContinueComparison",
  "bikiniContinueConditions",
  "bikiniContinueGuarantee",
  "bikiniContinueFinalCta",
  "bikiniContinueFooter",
  "bikiniContinueCheckoutIntro",
  "bikiniContinueCheckoutPriceSummary",
  "bikiniContinueCheckoutBenefits",
  "bikiniContinueCheckoutGuarantee",
  "bikiniContinueCheckoutPayment",
  "bikiniContinueCheckoutFaq",
  "bikiniContinueThankYou",
] as const;
